import MediaItem from "../upload/MediaItem";


class MediaSelectableItem extends MediaItem {
    constructor(html, name, when) {
        super(html, name, when);
    }

    loadFromDom() {
        const tds = this.html.find('td');

        if(tds.length < 3) {
            // Failsafe: If this is running, someone broke the template
            throw new Error("Cannot find td in template. Is template missing/modified?");
        }

        const checkboxGroup = tds[0].children[0];
        const checkbox = {
            group: checkboxGroup,
            input: checkboxGroup.children[0],
            label: checkboxGroup.children[1],
        };

        const nameField = tds[1];
        this.name = nameField.textContent;

        const whenField = tds[2];
        this.when = whenField.textContent;

        // allow mediaitem to carry the checkbox data as a property
        this.checkbox = checkbox;

        return this;
    }
}


export default MediaSelectableItem;